import { metis as viemMetis } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const metis = {
  displayName: 'Metis Andromeda',
  runtime: 'evm',
  viemChain: viemMetis,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'metis-andromeda' },
  }),
} as const satisfies AllChainConfig<'evm', false>;
